export const SCHEME_TYPE = {
    DETAIL: 'detail'
};

export const PROTOCOL_TYPE = {
    NN: 'ftnn',
    MOOMOO: 'ftmm'
};

const fnMap = {
    [SCHEME_TYPE.DETAIL]: ({ protocol, stock }) => `${protocol}://quote/stockDetail/${stock.stockId}/1`
};

export const getSchemeLink = (type, stock, protocol) => {
    return fnMap[type]?.({ protocol, stock }) || '';
};
